export default __webpack_public_path__ + "static/media/project_thumbnail_tbf.17b32105.png";